/**
 * react-qr-barcode-scanner's `onUpdate` delivers a ZXing `Result` OBJECT (see
 * its BarcodeScanner.js: `onUpdate(null, result)` and the `.d.ts`
 * `onUpdate: (arg0, arg1?: Result) => void`), whose decoded text is read via
 * `result.getText()`. Casting the object straight to `string` (the old bug)
 * both crashed `.substring` and queued an object as a React child.
 *
 * Normalise the callback argument to the decoded string: accept a plain string
 * (defensive — some builds/versions hand one back), otherwise call `getText()`.
 * Return `undefined` when there is no usable text so callers never set an
 * object into state or navigate on garbage.
 */
export function extractScannedText(result: unknown): string | undefined {
  if (typeof result === 'string') return result;
  if (
    result !== null &&
    typeof result === 'object' &&
    'getText' in result &&
    typeof (result as { getText: unknown }).getText === 'function'
  ) {
    const text = (result as { getText: () => unknown }).getText();
    return typeof text === 'string' ? text : undefined;
  }
  return undefined;
}
